// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"e57df2af","611":"a25cdcea","761":"fb79949a","947":"dadec2dd"}[chunkId] + ".chunk.js";
};